import React from "react";

import { func, object } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";

import { useSelector } from "react-redux";

import { uploadCsvCustomWatchlistIsLoadingSelector } from "../../selectors";
import { ButtonWithSpinner } from "../../../../components/common";
import UploadCustomWatchLists from "../../../../components/formik/uploadCustomWatchLists/UploadCustomWatchLists";
import { CUSTOM_WATCHLIST_UPLOAD_SUPPORTED_FORMATS } from "../../constants/formValidations";

const UploadCustomWatchlistsForm = ({
  handleSubmit,
  initialUploadCsvCustomWatchlist,
}) => {
  const isLoading = useSelector(uploadCsvCustomWatchlistIsLoadingSelector);

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialUploadCsvCustomWatchlist}
      enableReinitialize
    >
      <Form
        className="upload-custom-watchlist-form"
        name="uploadCustomWatchlistForm"
      >
        <Row className="center">
          <Col lg={3} />
          <Col className="d-flex flex-column align-items-center" lg={6}>
            <legend style={{ paddingBottom: 32 }}>
              Upload .CSV file with custom watchlists
            </legend>
            <p>
              The name of the file should be in the following format: <br />
              <b>[country-code]_[category-code]_[free-text].csv</b>
            </p>
            <Field
              name="csvFile"
              component={UploadCustomWatchLists}
              key={initialUploadCsvCustomWatchlist.randomNum}
              accept={CUSTOM_WATCHLIST_UPLOAD_SUPPORTED_FORMATS}
            />
            <ButtonWithSpinner
              className="upload-custom-watchlist-button"
              text="Upload"
              outline
              type="submit"
              loading={isLoading}
            />
          </Col>
          <Col lg={3} />
        </Row>
      </Form>
    </Formik>
  );
};

UploadCustomWatchlistsForm.propTypes = {
  handleSubmit: func.isRequired,
  initialUploadCsvCustomWatchlist: object.isRequired,
};

export default UploadCustomWatchlistsForm;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upload-csv-custom-watchlist-form/UploadCsvCustomWatchlistsForm.jsx